import React, { useEffect, useState } from 'react'
import {
  fetchEffects,
  deleteEffect,
  updateEffect,
  createEffect,
  fetchPhotoBooths
} from 'helpers/backend_helper'
import { Container } from 'reactstrap'
import BreadCrumb from 'Components/Common/BreadCrumb'
import { toast } from 'react-toastify'
import EffectsTable from './EffectsTable'
import EffectModal from './EffectModal'

export interface IEffect {
  _id?: string
  name: string
  imageLink: string
  translations: Record<string, string>
  isActive: boolean
  isActiveFor: string[]
}

export interface IPhotoBooth {
  _id: string
  name: string
}

const Effects = () => {
  document.title = 'Effects/Filters | SocialBooth - Admin Dashboard'

  const [fetching, setFetching] = useState<boolean>(false)
  const [effectRecords, setEffectRecords] = useState<IEffect[]>([])
  const [photoBooths, setPhotoBooths] = useState<IPhotoBooth[]>([])
  const [openEffectPopup, setOpenEffectPopup] = useState<boolean>(false)
  const [currentEffect, setCurrentEffect] = useState<IEffect>()
  const [editMode, setEditMode] = useState<boolean>(false)

  const fetchEffectRecords = async () => {
    try {
      setFetching(true)
      const response = await fetchEffects()
      if (Array.isArray(response.data)) {
        setEffectRecords(response.data)
      } else if (response.data.success) {
        setEffectRecords(response.data.data)
      }
      setFetching(false)
    } catch (e: any) {
      toast.error(typeof e === 'string' ? e : (e.message || 'Filtreler yüklenirken hata oluştu'))
      setFetching(false)
    }
  }

  const fetchBoothList = async () => {
    try {
      const response = await fetchPhotoBooths()
      if (Array.isArray(response.data)) {
        setPhotoBooths(response.data)
      } else if (response.data.success) {
        setPhotoBooths(response.data.data)
      }
    } catch (e: any) {
      console.error('Booth listesi yüklenemedi:', e)
    }
  }

  useEffect(() => {
    fetchEffectRecords()
    fetchBoothList()
  }, [])

  const handleOpenDetails = (id: string) => {
    const selectedEffect = effectRecords.find((eff) => eff._id === id)
    if (selectedEffect) {
      setCurrentEffect(selectedEffect)
      setOpenEffectPopup(true)
    }
  }

  const handleCreateOrUpdateEffect = async (params: any) => {
    try {
      const id = params instanceof FormData ? params.get('_id') as string : params._id
      const response: any = editMode
        ? await updateEffect(params, id)
        : await createEffect(params)

      if (response.success) {
        if (editMode) {
          const updatedRecords = effectRecords.map((eff: IEffect) => {
            if (eff._id === response.data._id) {
              return response.data
            }
            return eff
          })
          setEffectRecords(updatedRecords)
        } else {
          setEffectRecords([response.data, ...effectRecords])
        }
        return 'SUCCESSFULL'
      }
      return response.msg || 'Hata oluştu'
    } catch (e: any) {
      return typeof e === 'string' ? e : (e.message || 'Filtre kaydedilirken hata oluştu')
    }
  }

  const handleDeleteEffect = async (id: string) => {
    try {
      const response: any = await deleteEffect(id)
      if (response.success) {
        setEffectRecords(effectRecords.filter((eff) => eff._id !== id))
        return 'SUCCESSFULL'
      }
      return response.msg || 'Hata oluştu'
    } catch (e: any) {
      toast.error(typeof e === 'string' ? e : (e.message || 'Filtre silinirken hata oluştu'))
      return 'FALSE'
    }
  }

  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid>
          <BreadCrumb title='Effects/Filters' pageTitle='Asset Management' />
          <EffectsTable
            effectRecords={effectRecords}
            setOpenEffectPopup={setOpenEffectPopup}
            handleOpenDetails={handleOpenDetails}
            setEditMode={setEditMode}
            handleDeleteEffect={handleDeleteEffect}
            fetching={fetching}
          />
          <EffectModal
            isOpen={openEffectPopup}
            setOpenPopup={setOpenEffectPopup}
            handleCreateOrUpdateEffect={handleCreateOrUpdateEffect}
            effectRecord={currentEffect}
            editMode={editMode}
            photoBooths={photoBooths}
          />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Effects
